import { useEffect, useState } from 'react';
import PlayerListContainer from '../../components/PlayerListContainer';
import { useNavigate } from 'react-router-dom';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FaCirclePlus } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { useLocation } from 'react-router-dom';
import Layout from '../../layouts/Layout';
import { IoIosArrowDropleft } from "react-icons/io";
import { HashLoader } from 'react-spinners';


const PlayersList = () => {
    const [IsExclude, setExclude] = useState(false);
    const [favoriteList, setFavoriteList] = useState([]);
    const [exclusionList, setExclusionList] = useState([]);
    const navigate = useNavigate();
    const { accessToken } = useSelector((state) => state.loginInfo);
    const [invitePlayerList, setInvitePlayerList] = useState();
    const sportData = [{ id: 1, sportName: 'Tennis' }, { id: 2, sportName: 'PickBall' }];
    const location = useLocation();
    const playerGameProfileId = location.state?.playerGameProfileId;
    const [loader, setLoader] = useState(false);

    const fetchFavoriteList = async () => {
        setLoader(true);
        try {
            const result = await apiHandler({
                url: `${endpoint.PLAYER_FAVROUTE_LIST}?sportId=1`,
                authToken: accessToken.accessToken,
            });
            if (result?.data) {
                setLoader(false);
                setFavoriteList(result?.data);
            } else {
                setLoader(false);
                toast.success("somthing went wrong please try again");
            }
        } catch (error) {
            console.error('Error fetching favorite list:', error);
        }
    };

    const fetchExclusionList = async () => {
        setLoader(true);
        try {
            const result = await apiHandler({
                url: `${endpoint.PLAYER_ENCLUSTION_LIST}?sportId=${playerGameProfileId}`,
                authToken: accessToken.accessToken,
            });
            if (result?.data) {
                setLoader(false);
                setExclusionList(result?.data);
            } else {
                setLoader(false);
                toast.success("somthing went wrong please try again");
            }
        } catch (error) {
            console.error('Error fetching exclusion list:', error);
        }
    };

    const handleMoveToInclusionList = async (userId) => {
        try {
            await apiHandler({
                url: `${endpoint.MOVE_INTO_EXCLUSION_LIST}?userId=${userId}&sportId=${playerGameProfileId}`,
                method: 'POST',
                authToken: accessToken.accessToken,
            });
            fetchExclusionList();
            fetchFavoriteList();
        } catch (error) {
            console.error('Error moving to inclusion list:', error);
        }
    };

    const handleMoveToExclusionList = async (userId) => {
        try {
            await apiHandler({
                url: `${endpoint.MOVE_IN_PREFERABLE_LIST}?userId=${userId}&sportId=${playerGameProfileId}`,
                method: 'POST',
                authToken: accessToken.accessToken,
            });
            fetchExclusionList();
            fetchFavoriteList();
            toast.success('User moved to exclusion list successfully!');
        } catch (error) {
            console.error('Error moving to exclusion list:', error);
        }
    };

    useEffect(() => {
        fetchFavoriteList();
        fetchExclusionList();
    }, []);

    const CustomButton = ({ userId }) => (
        <button
            style={{
                width: "91px",
                height: "38px",
                borderRadius: "12px",
                color: "#FF616D",
                border: '1px solid #FF616D',
                background: 'transparent',
                cursor: 'pointer',
            }}
            onClick={() => handleMoveToInclusionList(userId)}
        >
            Exclude
        </button>
    );

    const ExcludeButton = ({ userId }) => (
        <button
            style={{
                width: "91px",
                height: "38px",
                borderRadius: "12px",
                color: "#006FFD",
                border: '1px solid #006FFD',
                background: 'transparent',
                cursor: 'pointer',
            }}
            onClick={() => handleMoveToExclusionList(userId)}
        >
            Fav List
        </button>
    );

    const onOpenInvitePlayer = () => {
        const fetchData = async () => {
            const url = IsExclude
                ? `${endpoint.GET_INVITE_EXCLUSION_LIST}?sportId=${playerGameProfileId}`
                : `${endpoint.GET_INVITE_INCLUSION_LIST}?sportId=${playerGameProfileId}`;
            try {
                const result = await apiHandler({
                    url,
                    authToken: accessToken.accessToken,
                });
                if (result.data) {
                    setInvitePlayerList(result?.data);
                    navigate('./invite-player', {
                        state: { invitePlayerList: result?.data, IsExclude },
                    });
                } else {

                }
            } catch (error) {
                console.error('Error fetching invite list:', error);
            }
        };
        fetchData();
    };

    const onInClude = async (UserId, sportName) => {
        const sportId = sportData.find(s => s.sportName === sportName)?.id;
        try {
            const result = await apiHandler({
                url: `${endpoint.DELETE_INCLUTION_LIST}?userId=${UserId}&sportId=${sportId}`,
                method: 'POST',
                authToken: accessToken.accessToken,
            });
            if (result.data) {
                toast.success("Deleted Successfully");
                fetchFavoriteList();
            }
        } catch (error) {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const onExclude = async (UserId, sportName) => {
        const sportId = sportData.find(s => s.sportName === sportName)?.id;
        try {
            const result = await apiHandler({
                url: `${endpoint.DELETE_EXCLUSION_LIST}?userId=${UserId}&sportId=${sportId}`,
                method: 'POST',
                authToken: accessToken.accessToken,
            });
            if (result.data) {
                toast.success("Deleted Successfully");
                fetchExclusionList();
            }
        } catch (error) {
            toast.error("Something went wrong. Please try again.");
        }
    };
    const onGoToBackPage = () => {
        navigate(-1);
    }

    return (
        <Layout>
            <div className='w-100 players-list-wrapper bg-sm-white p-3 p-sm-4'  >
                <div className="d-flex justify-content-between your-sport-player-wrapper"  >
                    <button className='back-page-btn d-flex justify-content-between'  style={{ cursor: 'pointer', fontSize: '16px' }}  onClick={onGoToBackPage}> <IoIosArrowDropleft style={{fontSize:'31px'}}/> <span> Back </span></button>
                    <h3 className="text-center mb-4 edit-profile-txt fs-3">Player List</h3>
                </div>
                <div className="text-end mb-3 mb-sm-0">
                    <FaCirclePlus style={{ fontSize: '35px', color: '#006FFD', cursor: 'pointer' }} onClick={onOpenInvitePlayer} />
                </div>
                <div className="row mb-3">
                    <div className="col d-flex justify-content-around">
                        <div
                            style={{ borderBottom: !IsExclude ? '2px solid #006FFD' : 'none', }}
                            className='favorite-list-text'
                            onClick={() => setExclude(false)}
                        >
                            Favorite List
                        </div>
                        <div
                            style={{ color: '#006FFD', cursor: 'pointer', fontSize: '17px', fontFamily: 'INTER', fontWeight: '500', borderBottom: IsExclude ? '2px solid #006FFD' : 'none', }}
                            onClick={() => setExclude(true)}
                        >
                            Exclusion List
                        </div>
                    </div>
                </div>

                <div>
                    <div className="row " style={{ rowGap: '25px' }}>
                        {(IsExclude ? exclusionList : favoriteList)?.map((player) => (
                            <div className="col-lg-4" key={player.excludedUserId || player.preferredUserId}>
                                <PlayerListContainer
                                    player={{
                                        avatarName: player.avatarName,
                                        name: player?.preferredUserName || player.excludedUserName,
                                        avatarUrl: player?.avatarUrl || player?.image,
                                        age: player?.age,
                                        skill: player?.skillLevel,
                                        reliabilty: player.reliability,
                                        distance: player.distance,
                                        sports: player.sportName,
                                        gender: player.gender,
                                        sport: player.sportName
                                    }}
                                    deleteIcon={
                                        IsExclude ? (
                                            <MdDelete className="delete-icon" onClick={() => onExclude(player?.excludedUserId, player.sportName)} />
                                        ) : (
                                            <MdDelete className="delete-icon" onClick={() => onInClude(player?.preferredUserId, player.sportName)} />
                                        )
                                    }
                                    CustomButton={() =>
                                        IsExclude ? (
                                            <ExcludeButton userId={player.excludedUserId} />
                                        ) : (
                                            <CustomButton userId={player.excludedUserId || player.preferredUserId} />
                                        )
                                    }
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {loader && <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
                < HashLoader color="#e48181" />
            </div>}
        </Layout>
    );
};

export default PlayersList;
